export const BLANK_LAYOUT_PDF_LINK =
  'https://drive.google.com/file/d/1GDKBPf2uCoteYM5kPPXRGhE76z_P2ZjN/view?usp=drivesdk'
export const BLANK_LAYOUT_FOLDER_LINK =
  'https://drive.google.com/drive/folders/1AZtXUkaDBTjc1gU-k7YbZ7zzIiV44ru3'
